// Vue
import { Vue, Component, Prop, Inject, Watch } from "vue-property-decorator";

// Template
import template from "./template.vue";

import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";
import ModuleBase from "#/common/ModuleBase";

import { Headline } from "#/components/headline/Headline";
import { Api } from "#/api";

@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
    Headline,
  },
})
export class KeyFiguresModule extends ModuleBase {
  private keyfiguresFilter = {};

  public getBackgroundColorFromInstance(instance: object) {
    return instance["background"];
  }

  public buttonTheme(button) {
    switch (button["button"]["button_type"]) {
      case "wb-e-btn-1":
        return "primary";
      case "wb-e-btn-2":
        return "default";
      case "wb-e-btn-3":
        return "inverted";
      case "button_outline":
        return "outline-secondary";
      default:
        return "default";
    }
  }

  public mounted() {
    this.loadData();
  }

  @Watch("instance")
  public onInstanceChange() {
    this.loadData();
  }

  public loadData() {
    this.keyfiguresFilter = {};
    this.instance["keyfigures_section"]["keyfigures"]
      .slice()
      .forEach((keyfigure) => {
        if (
          keyfigure["number"]["service"] !=
          "Common/Application/Domain/Services/Search/TextInput"
        ) {
          this.getKeyFigureFilter(keyfigure["number"]["filter"]["FILTER"]);
        }
      });
  }

  public async getKeyFigureFilter(id: number) {
    let result = await Api.kpiService.getFilterData(id);
    this.$set(this.keyfiguresFilter, id, result.count);
  }
}
